/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React from 'react';
import { Box, Modal, IconButton, Typography, CircularProgress } from '@mui/material';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MultiplicationSignStrokeStandard } from '@hugeicons-pro/core-stroke-standard';
import { getTemplateContent } from '../../services/templateService';
// @ts-ignore
import { NotificationManager } from 'react-notifications';

interface PreviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    content: string;
    campaignType?: string;
    campaignId?: string | number;
}

interface TemplateApiResponse {
    status: number;
    data: {
        result: number;
        data: string | null;
        messages: string;
        transactionId: string;
    };
}

const TemplatePreview = ({ isOpen, onClose, content, campaignType, campaignId }: PreviewModalProps): JSX.Element => {
    const [loading, setLoading] = React.useState(false);
    const [fetchedContent, setFetchedContent] = React.useState<string>('');

    React.useEffect(() => {
        if (isOpen && campaignType && campaignId) {
            setLoading(true);
            getTemplateContent(campaignType, campaignId)
                .then((res: unknown) => {
                    const typedRes = res as TemplateApiResponse;
                    if (typedRes.status === 200 && typedRes.data.result === 1 && typedRes.data.data !== "" && typedRes.data.data !== null) {
                        setFetchedContent(typedRes.data.data);
                    } else if (typedRes.data.result === 0 || typedRes.data.data === "" || typedRes.data.data === null) {
                        onClose();
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                        NotificationManager.error(typedRes.data.messages || "Template Content fetch failed.");
                    } else {
                        setFetchedContent(content);
                    }
                })
                .catch((err: Error) => {
                    console.error("Error fetching template content:", err);
                    setFetchedContent(content);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else if (isOpen) {
            setFetchedContent(content);
        }
    }, [isOpen, campaignType, campaignId, content]); // Removed onClose from dependencies as it's a stable prop from parent

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '90%',
                maxWidth: 700,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 2,
                outline: 'none',
                borderRadius: 2,
                height: '90%'
            }}>
                {/* Close Button */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography id="server-modal-title" sx={{ m: 0, p: 0, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }}>
                        Template Preview
                    </Typography>
                    <IconButton onClick={onClose}>
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />


                    </IconButton>
                </Box>

                {/* Loader or Iframe for HTML Content */}
                <Box sx={{ maxHeight: '100%', height: '90%', overflowY: 'auto', mt: 2, display: 'flex', justifyContent: 'center', alignItems: loading ? 'center' : 'stretch' }}>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <iframe
                            srcDoc={fetchedContent}
                            title="HTML Preview"
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                        />
                    )}
                </Box>
            </Box>
        </Modal>
    );
};

export default TemplatePreview;